
import { Injectable } from '@angular/core';
import { isEmptyString, isNull } from '../../../util/check';
import { FNTimeData, ShiftSlot } from './timepicker.model';

@Injectable({
  providedIn: 'root'
})
export class FnTimepickerService {

  readonly KEY_CODES = {
    BACKSPACE: 8,
    ENTER: 'Enter',
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp'
  };
  isMilitaryTime = false;
  regexMap = {
    digitRegex: new RegExp(/^(\d)*$/),
    durationValueRegex: new RegExp(/^(\d)*(\:)(\d)*$/),
    validValueRegex: new RegExp(/^(\d)*(:)(\d{2})=?/),
    regexMilitary: new RegExp('^(0[0-9]|1[0-9]|2[0-3]):(00|15|30|45)$'),
    regex12ap: new RegExp('^([1-9]|0[1-9]|1[0-2]):(00|15|30|45)(a|p)$'),
    regexMilitaryNext: new RegExp('^(0[0-9]|1[0-9]|2[0-3]):(00|15|30|45)( \\+1 D)?$'),
    regex12apNext: new RegExp('^([1-9]|0[1-9]|1[0-2]):(00|15|30|45)(a|p)( \\+1 D)?$'),
    endWith12aOrp: new RegExp('^([1-9]|1[012])(a|p)( \\+1 D)?$')
  };
  regex12a = new RegExp('^([1-9]|1[012])(a)$');
  regex12p = new RegExp('^([1-9]|1[012])(p)$');
  readonly Hour12Format = [
    '12:00a', '12:15a', '12:30a', '12:45a',
    '1:00a', '1:15a', '1:30a', '1:45a',
    '2:00a', '2:15a', '2:30a', '2:45a',
    '3:00a', '3:15a', '3:30a', '3:45a',
    '4:00a', '4:15a', '4:30a', '4:45a',
    '5:00a', '5:15a', '5:30a', '5:45a',
    '6:00a', '6:15a', '6:30a', '6:45a',
    '7:00a', '7:15a', '7:30a', '7:45a',
    '8:00a', '8:15a', '8:30a', '8:45a',
    '9:00a', '9:15a', '9:30a', '9:45a',
    '10:00a', '10:15a', '10:30a', '10:45a',
    '11:00a', '11:15a', '11:30a', '11:45a',

    '12:00p', '12:15p', '12:30p', '12:45p',
    '1:00p', '1:15p', '1:30p', '1:45p',
    '2:00p', '2:15p', '2:30p', '2:45p',
    '3:00p', '3:15p', '3:30p', '3:45p',
    '4:00p', '4:15p', '4:30p', '4:45p',
    '5:00p', '5:15p', '5:30p', '5:45p',
    '6:00p', '6:15p', '6:30p', '6:45p',
    '7:00p', '7:15p', '7:30p', '7:45p',
    '8:00p', '8:15p', '8:30p', '8:45p',
    '9:00p', '9:15p', '9:30p', '9:45p',
    '10:00p', '10:15p', '10:30p', '10:45p',
    '11:00p', '11:15p', '11:30p', '11:45p','11:59p'
  ];

  readonly Hour12NextFormat = [
    '12:00a', '12:15a', '12:30a', '12:45a',
    '1:00a', '1:15a', '1:30a', '1:45a',
    '2:00a', '2:15a', '2:30a', '2:45a',
    '3:00a', '3:15a', '3:30a', '3:45a',
    '4:00a', '4:15a', '4:30a', '4:45a',
    '5:00a', '5:15a', '5:30a', '5:45a',
    '6:00a', '6:15a', '6:30a', '6:45a',
    '7:00a', '7:15a', '7:30a', '7:45a',
    '8:00a', '8:15a', '8:30a', '8:45a',
    '9:00a', '9:15a', '9:30a', '9:45a',
    '10:00a', '10:15a', '10:30a', '10:45a',
    '11:00a', '11:15a', '11:30a', '11:45a',

    '12:00p', '12:15p', '12:30p', '12:45p',
    '1:00p', '1:15p', '1:30p', '1:45p',
    '2:00p', '2:15p', '2:30p', '2:45p',
    '3:00p', '3:15p', '3:30p', '3:45p',
    '4:00p', '4:15p', '4:30p', '4:45p',
    '5:00p', '5:15p', '5:30p', '5:45p',
    '6:00p', '6:15p', '6:30p', '6:45p',
    '7:00p', '7:15p', '7:30p', '7:45p',
    '8:00p', '8:15p', '8:30p', '8:45p',
    '9:00p', '9:15p', '9:30p', '9:45p',
    '10:00p', '10:15p', '10:30p', '10:45p',
    '11:00p', '11:15p', '11:30p', '11:45p',
    '12:00a +1 D', '12:15a +1 D', '12:30a +1 D', '12:45a +1 D',
    '1:00a +1 D', '1:15a +1 D', '1:30a +1 D', '1:45a +1 D',
    '2:00a +1 D', '2:15a +1 D', '2:30a +1 D', '2:45a +1 D',
    '3:00a +1 D', '3:15a +1 D', '3:30a +1 D', '3:45a +1 D',
    '4:00a +1 D', '4:15a +1 D', '4:30a +1 D', '4:45a +1 D',
    '5:00a +1 D', '5:15a +1 D', '5:30a +1 D', '5:45a +1 D',
    '6:00a +1 D', '6:15a +1 D', '6:30a +1 D', '6:45a +1 D',
    '7:00a +1 D', '7:15a +1 D', '7:30a +1 D', '7:45a +1 D',
    '8:00a +1 D', '8:15a +1 D', '8:30a +1 D', '8:45a +1 D',
    '9:00a +1 D', '9:15a +1 D', '9:30a +1 D', '9:45a +1 D',
    '10:00a +1 D'
  ];


  readonly Hour24Format = [
    '00:00', '00:15', '00:30', '00:45',
    '01:00', '01:15', '01:30', '01:45',
    '02:00', '02:15', '02:30', '02:45',
    '03:00', '03:15', '03:30', '03:45',
    '04:00', '04:15', '04:30', '04:45',
    '05:00', '05:15', '05:30', '05:45',
    '06:00', '06:15', '06:30', '06:45',
    '07:00', '07:15', '07:30', '07:45',
    '08:00', '08:15', '08:30', '08:45',
    '09:00', '09:15', '09:30', '09:45',
    '10:00', '10:15', '10:30', '10:45',
    '11:00', '11:15', '11:30', '11:45',

    '12:00', '12:15', '12:30', '12:45',
    '13:00', '13:15', '13:30', '13:45',
    '14:00', '14:15', '14:30', '14:45',
    '15:00', '15:15', '15:30', '15:45',
    '16:00', '16:15', '16:30', '16:45',
    '17:00', '17:15', '17:30', '17:45',
    '18:00', '18:15', '18:30', '18:45',
    '19:00', '19:15', '19:30', '19:45',
    '20:00', '20:15', '20:30', '20:45',
    '21:00', '21:15', '21:30', '21:45',
    '22:00', '22:15', '22:30', '22:45',
    '23:00', '23:15', '23:30', '23:45','23:59'
  ];

  readonly Hour24NextFormat = [
    '00:00', '00:15', '00:30', '00:45',
    '01:00', '01:15', '01:30', '01:45',
    '02:00', '02:15', '02:30', '02:45',
    '03:00', '03:15', '03:30', '03:45',
    '04:00', '04:15', '04:30', '04:45',
    '05:00', '05:15', '05:30', '05:45',
    '06:00', '06:15', '06:30', '06:45',
    '07:00', '07:15', '07:30', '07:45',
    '08:00', '08:15', '08:30', '08:45',
    '09:00', '09:15', '09:30', '09:45',
    '10:00', '10:15', '10:30', '10:45',
    '11:00', '11:15', '11:30', '11:45',

    '12:00', '12:15', '12:30', '12:45',
    '13:00', '13:15', '13:30', '13:45',
    '14:00', '14:15', '14:30', '14:45',
    '15:00', '15:15', '15:30', '15:45',
    '16:00', '16:15', '16:30', '16:45',
    '17:00', '17:15', '17:30', '17:45',
    '18:00', '18:15', '18:30', '18:45',
    '19:00', '19:15', '19:30', '19:45',
    '20:00', '20:15', '20:30', '20:45',
    '21:00', '21:15', '21:30', '21:45',
    '22:00', '22:15', '22:30', '22:45',
    '23:00', '23:15', '23:30', '23:45',
    '00:00 +1 D', '00:15 +1 D', '00:30 +1 D', '00:45 +1 D',
    '01:00 +1 D', '01:15 +1 D', '01:30 +1 D', '01:45 +1 D',
    '02:00 +1 D', '02:15 +1 D', '02:30 +1 D', '02:45 +1 D',
    '03:00 +1 D', '03:15 +1 D', '03:30 +1 D', '03:45 +1 D',
    '04:00 +1 D', '04:15 +1 D', '04:30 +1 D', '04:45 +1 D',
    '05:00 +1 D', '05:15 +1 D', '05:30 +1 D', '05:45 +1 D',
    '06:00 +1 D', '06:15 +1 D', '06:30 +1 D', '06:45 +1 D',
    '07:00 +1 D', '07:15 +1 D', '07:30 +1 D', '07:45 +1 D',
    '08:00 +1 D', '08:15 +1 D', '08:30 +1 D', '08:45 +1 D',
    '09:00 +1 D', '09:15 +1 D', '09:30 +1 D', '09:45 +1 D',
    '10:00 +1 D'
  ];

  getFormatedTime(timeIndex: number) {
    return this.isMilitaryTime ? this.Hour24Format[timeIndex] : this.Hour12Format[timeIndex];
  }
  getIndexForOneDayFormat(timeVal: string) {
    const valueArray = timeVal.split(':');
    let startValue = Number(valueArray[0]);
    if (this.regexMap.regex12ap.test(timeVal)) {
      const endChar = timeVal[timeVal.length - 1];
      if (startValue === 12) {
        startValue = endChar === 'a' ? 0 : startValue;
      } else {
        startValue = endChar === 'a' ? startValue : 12 + startValue;
      }
    }
    startValue = startValue * 4;
    const endValue = Number(valueArray[1].substring(0, 2)) / 15;
    return startValue + endValue;
  }

  shiftSlotTimeForSchedule(shiftSlot: ShiftSlot, showOverNight: boolean, orgTime: number, timeArray?: string[], isTimeShow?: boolean) {
    if (shiftSlot.startIndex === 0 + orgTime && shiftSlot.endIndex === 95 + orgTime && !isTimeShow) {
      return "ALL DAY";
    }
    const filteredArr = timeArray || this.create48HrsTimeStampArrayForUIDisplay(orgTime);
    const conCatStr = isTimeShow ? " to " : "-";
    const startIndex = shiftSlot.actualStartIndex ? shiftSlot.actualStartIndex : shiftSlot.startIndex;
    const endIndex = shiftSlot.actualEndIndex ? shiftSlot.actualEndIndex : shiftSlot.endIndex;
    const newStartIndex = this.checkTimeInterval(startIndex, orgTime);
    const newEndIndex = this.checkTimeInterval((endIndex + 1), orgTime);
    let formattedEndIndex = filteredArr[newEndIndex - orgTime];
    formattedEndIndex = (showOverNight === true || isNull(showOverNight)) ? (formattedEndIndex) : (formattedEndIndex.replace(' +1 D', ''));
    return filteredArr[newStartIndex - orgTime] + conCatStr + formattedEndIndex;
  }

  create24HrsTimeStampArray(sInd: number) {
    const minsValue = this.getMinsFromTimeStamp(this.Hour12Format[sInd]);
    const objHash = {
      startTime: minsValue
    }
    const array1 = this.getTimeArray(objHash, 24 * 60);
    objHash.startTime = 0;
    const array2 = this.getTimeArray(objHash, minsValue);
    return array1.concat(array2);
  }

  create48HrsTimeStampArrayForUIDisplay(sInd: number) {
    let minsValue = this.getMinsFromTimeStamp(this.Hour12Format[sInd]);
    const objHash = {
      startTime: minsValue
    }
    const array1 = this.getTimeArray(objHash, 24 * 60);
    objHash.startTime = 0;
    const array2 = this.getTimeArray(objHash, minsValue);
    let startTime3 = objHash.startTime;
    let array3 = this.getTimeArray(objHash, 24 * 60, ' +1 D')
    objHash.startTime = 0;
    let array4 = this.getTimeArray(objHash, startTime3, ' +1 D');
    return array1.concat(array2, array3, array4);
  }

  public getTimeArray(obj: { startTime: number }, endTime: number, endString = '', minDiff = 15,
    isMilitaryTime = false
  ) {
    const isMilitaryFormat = this.isMilitaryTime || isMilitaryTime;
    const timeArray: string[] = [];
    const ap = ['a', 'p'];
    for (let i = 0; obj.startTime < endTime; i++) {
      const hour = Math.floor(obj.startTime / 60);
      const mins = (obj.startTime % 60);
      timeArray[i] = ('' + (hour == 0 || hour == 12 ? '12' : hour % 12)).slice(-2) + ':' + ("0" + mins).slice(-2) + ap[Math.floor(hour / 12)];
      timeArray[i] = this.formattedMiltrayTime(timeArray[i], isMilitaryFormat) + endString;
      obj.startTime = obj.startTime + minDiff;
    }
    return timeArray;
  }

  formattedMiltrayTime(strValue: string, isMiltrayTime: boolean) {
    if (strValue) {
      const splitStr = strValue.split(':');
      splitStr[0] = splitStr[0].length === 1 ? '0' + splitStr[0] : splitStr[0];
      if (strValue.toLowerCase().endsWith('p') && isMiltrayTime) {
        return (splitStr[0] == '12' ? '12' : (parseInt(splitStr[0]) + 12)) + ':' + splitStr[1].replace('p', '');
      } else if (strValue.toLowerCase().endsWith('a') && isMiltrayTime) {
        return (splitStr[0] == '12' ? '00' : splitStr[0]) + ':' + splitStr[1].replace('a', '');
      } else {
        return strValue;
      }
    } else {
      return strValue;
    }

  }

  getMinsFromTimeStamp(strValue: string) {
    let splitStr = strValue.split(':');
    if (strValue.endsWith('p')) {
      return ((Number(splitStr[0]) + 12) * 60) + Number(splitStr[1].replace('p', ''));
    } else if (strValue.endsWith('a')) {
      return (Number(splitStr[0] == '12' ? 0 : splitStr[0]) * 60) + Number(splitStr[1].replace('a', ''));
    }
    return null;
  }

  checkTimeInterval(ind: number, orgTime: number) {
    let index = ind;
    if (ind > 192) {
      index = ind - 96;
    }
    if ((index - orgTime) < 0) {
      index = index + 96;
    }
    return index;
  }

  getTimeStrFromMinute(ttlMinutes: number, isMiltary?: boolean, showOverNight: boolean = true) {
    const totalHours = Math.floor(ttlMinutes / 60);
    let hours = totalHours >= 24 ? totalHours - 24 : totalHours;
    const minutes = ttlMinutes % 60;
    const meridian = totalHours >= 24 && showOverNight ? ' +1 D' : '';
    const minuteStr = (minutes < 10 ? ':0' : ':') + minutes;
    if (isMiltary) {
      return `${hours < 10 ? '0' + hours : hours}${minuteStr}${meridian}`;
    } else {
      const ampm: string = hours < 12 ? 'a' : 'p';
      hours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      return `${hours}${minuteStr}${ampm}${meridian}`;
    }
  }

  getSelectedIndexForTime(timeVal: string): FNTimeData {
    const resp = new FNTimeData();
    if (this.isNotNumber(timeVal)) {
      let newVal = timeVal;
      let isPM = timeVal.endsWith("p");
      if (timeVal.endsWith("a")) {
        newVal = timeVal.replace("a", "");
        resp.timeString = this.isNotNumber(newVal)
          ? this.timeStrifColon(newVal)
          : this.getTimpickerStr(newVal);
      } else if (isPM) {
        newVal = timeVal.replace("p", "");
        resp.timeString = this.isNotNumber(newVal)
          ? this.timeStrifColon(newVal, isPM)
          : this.getTimpickerStr(newVal, isPM);
      } else {
        resp.timeString = this.timeStrifColon(timeVal, isPM);
      }
    } else if (timeVal.length < 5) {
      resp.timeString = this.getTimpickerStr(timeVal);
    }
    if (!isEmptyString(resp.timeString)) {
      resp.minute = this.getMinuFromMilitaryTime(resp.timeString);
    }
    return resp;
  }

  private timeStrifColon(timeValue: string, isPm?: boolean) {
    const strArray = timeValue.split(":");
    if (
      strArray.length < 3 &&
      !(this.isNotNumber(strArray[0]) || this.isNotNumber(strArray[1]))
    ) {
      return this.getTimpickerStr(
        this.getTimeHourMinToTwoDigit(Number(strArray[0])) +
        "" +
        this.getTimeHourMinToTwoDigit(Number(strArray[1])),
        isPm
      );
    }
    return "";
  }

  private getTimpickerStr(timeValue: string, isPm?: boolean) {
    let startNum = Number(timeValue.substring(0, 2));
    const endNum = Number(timeValue.substring(2, 4));
    if (
      timeValue.length < 5 &&
      startNum > -1 &&
      endNum > -1 &&
      ((startNum < 24 && endNum < 61) || (startNum === 24 && endNum === 0))
    ) {
      let startStr = "";
      startNum =
        isPm && startNum < 12 ? startNum + 12 : isPm && startNum == 12 ? 12 : startNum == 12 ? 0 : startNum;
      startStr = this.getTimeHourMinToTwoDigit(startNum);
      const endStr = this.getTimeHourMinToTwoDigit(endNum);
      return startStr + ":" + endStr;
    }
    return "";
  }

  private getTimeHourMinToTwoDigit(timeVal: number) {
    return timeVal < 10 ? "0" + timeVal : timeVal + "";
  }

  getMinuFromMilitaryTime(timeStr: string) {
    const timeArray = timeStr.split(":");
    return Number(timeArray[0]) * 60 + Number(timeArray[1]);
  }

  private isNotNumber(timeVal: string) {
    return isNaN(Number(timeVal));
  }


  createDayColObjectArray(includeHalfInterval = false, isFullDay = false) {
    const interval = includeHalfInterval ? 48 : 24;
    const timeArray: { hoursIndex: number, name: string }[] = [];
    const startIndex = isFullDay ? 0 : 1;
    for (let index = startIndex; index <= interval; index++) {
      let tempObj = {
        hoursIndex: index,
        name: this.dayColValueForIndex(index, interval, isFullDay)
      };
      timeArray.push(tempObj);
    }
    return timeArray;
  }

  dayColValueForIndex(index: number, interval: number, isFullDay = false) {
    let value = isFullDay ? index : index - 1;
    if (interval == 24) {
      return this.getHourStrFromMinute(value * 60, this.isMilitaryTime);
    } else if (interval == 48) {
      return this.dayColHrsFormat(value * 30);
    }
    return value + "";
  };


  getHourStrFromMinute(ttlMinutes: number, isMiltary?: boolean) {
    ttlMinutes = ttlMinutes >= 1440 ? ttlMinutes - 1440 : ttlMinutes;
    let hours = Math.floor(ttlMinutes / 60);
    if (!isMiltary) {
      const meridian = hours >= 12 ? 'p' : 'a';
      hours = hours > 12 ? hours - 12 : hours == 0 ? 12 : hours;
      return hours + meridian;
    } else {
      return hours + '';
    }
  }

  dayColHrsFormat(mins: number) {
    let hours: number | string = Math.floor(mins / 60);
    let remMins: number | string = Math.floor(mins % 60);
    remMins = remMins > 9 ? remMins : "0" + remMins
    if (this.isMilitaryTime) {
      return (hours > 9 ? hours : +"0" + hours) + ":" + remMins;
    }
    if (hours == 0) {
      hours = 12;
    }
    const isPM = hours > 12;
    hours = isPM ? hours - 12 : hours;
    hours = hours > 9 ? hours : "0" + hours;
    return hours + ":" + remMins + (isPM ? "PM" : "AM");
  }

}
